import React, { useEffect, useState } from "react";
import SelectFromLibr from "../../Add_From_Library/Select_from_Library/SelectFromLibr";
// css comes in create_hw_file.css in homework
import { useNavigate } from 'react-router-dom';
import DefaultQuestion from "./DefaultQuestion";
import QuestionListAssessment from "../Preview_Question_List/QuestionListAssessment";
import axios from "../../../../axios";
import "./../create/create.css"


const CreateQuestion = ({
  setClickFromCreate,
  assessmentDetails,
  setAssessmentDetails,
}) => {
  const {
    standard_id,
    subject_id,
    section_id,
    total_duration,
    name,
    description,
  } = assessmentDetails;
  const navigate = useNavigate();
  const [click, setClick] = useState(false);
  const [click1, setClick1] = useState(false);
  const [sourceLibrary, setSourceLibrary] = useState(null)
  const [isInProgress, setIsInProgress] = useState(false);
  const [skillsData, setSkillsData] = useState([])
  const [difficulty_levelData, setDifficulty_levelData] = useState([])
  const [questionType, setQuestionType] = useState([])
  const [countSkills, setCountSkills] = useState([])
  const [countDifficulty, setCountDifficulty] = useState([])
  const [countQsType, setCountQsType] = useState([])
  const [questions, setQuestions] = useState([
    {
      standard_id: standard_id ? standard_id?.id : null,
      subject_id: subject_id ? subject_id?.id : null,
      section_id: section_id ? section_id?.id : null,
      book_id: "633c5ac7629a3af66952fa5c",
      chapter_id: null,
      type_id: null,
      question_type: "null",
      domain_id: null,
      skill_id: null,
      difficulty_level: null,
      title: null,
      correct_score: null,
      is_mandatory: false,
      add_to: null,
      attachments: [],
      options: [
        {
          key: "A",
          value: null,
        },
        {
          key: "B",
          value: null,
        },
      ],
      correct_answers: [
        {
          option_key: null,
          value: null,
          reason_for_answer: {
            explanation: null,
          },
        },
      ],
    },
  ]);


  const addMoreQuestion = () => {
    setQuestions((prev) => [
      ...prev,
      {
        standard_id: standard_id ? standard_id?.id : null,
        subject_id: subject_id ? subject_id?.id : null,
        section_id: section_id ? section_id?.id : null,
        book_id: "633c5ac7629a3af66952fa5c",
        chapter_id: null,
        question_type: "null",
        type_id: null,
        domain_id: null,
        skill_id: null,
        difficulty_level: null,
        title: null,
        correct_score: null,
        is_mandatory: false,
        add_to: null,
        attachments: [],
        options: [
          {
            key: "A",
            value: null,
          },
          {
            key: "B",
            value: null,
          },
        ],
        correct_answers: [
          {
            option_key: null,
            value: null,
            reason_for_answer: {
              attachment: null,
              explanation: null,
            },
          },
        ],
      },
    ]);
  };

  const checkAllDataField = () => {
    if (
      !questions[questions.length - 1].title ||
      !questions[questions.length - 1].skill_id ||
      !questions[questions.length - 1].domain_id ||
      !questions[questions.length - 1].type_id ||
      !questions[questions.length - 1].chapter_id ||
      !questions[questions.length - 1].correct_score ||
      !questions[questions.length - 1].difficulty_level ||
      (questions[questions.length - 1]?.options?.length > 0 &&
        questions[questions.length - 1].options.some(
          (opt) => opt?.value === null || opt?.value.trim() === ""
        )) ||
      (questions[questions.length - 1]?.options?.length > 0 &&
        questions[questions.length - 1]?.correct_answers.length > 0 &&
        questions[questions.length - 1].correct_answers.some(
          (opt) =>
            !opt?.option_key &&
            (opt?.option_key === null || opt?.option_key === "")
        ))
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleCreateAssessment = async () => {
    setIsInProgress(true);
    let newAssessment = {
      name: assessmentDetails.name,
      description: assessmentDetails.description,
      type_id: assessmentDetails.type_id,
      standard_id: assessmentDetails.standard_id?.id,
      subject_id: assessmentDetails.subject_id?.id,
      teacher_id: assessmentDetails.teacher_id,
      section_id: assessmentDetails.section_id?.id,
      tags: assessmentDetails.tags,
      status: "draft",
      total_duration: assessmentDetails.total_duration,
      questions: questions,
    };

    try {
      let res = await axios.post(`/api/v1/assessment/create`, newAssessment);
      res && navigate("/PublishedAssessment?status=Draft");
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };

  const findTotalMarks = () => {
    return questions.reduce((acc, curr) => acc + Number(curr.correct_score), 0);
  };

  useEffect(() => {
    const dataCounter = {
      Skills: {},
      DifficultyLevel: {},
      QuestionType: {}
    }
    questions.map((item, index) => {
      const correctScore = Number(item.correct_score);
      if (item.question_type !== null) {
        if (dataCounter['QuestionType'][item.question_type] === undefined) {
          dataCounter['QuestionType'][item.question_type] = correctScore
        } else {
          setCountDifficulty({})
          dataCounter['QuestionType'][item.question_type] += correctScore
        }
      }
      if (item.question_type !== null) {
        if (dataCounter['Skills'][item.skill_id] === undefined) {
          dataCounter['Skills'][item.skill_id] = correctScore
        } else {
          setCountDifficulty({})
          dataCounter['Skills'][item.skill_id] += correctScore
        }
      }
      if (item.question_type !== null) {
        if (dataCounter['DifficultyLevel'][item.difficulty_level] === undefined) {
          dataCounter['DifficultyLevel'][item.difficulty_level] = correctScore
        } else {
          dataCounter['DifficultyLevel'][item.difficulty_level] += correctScore
        }
      }

    })

    setCountQsType(dataCounter)
    setCountSkills(dataCounter)
    setCountDifficulty(dataCounter)
    // question_type,skill_id,difficulty_level
  }, [questions])
  return (
    <div>
      {console.log("question123", questions)}
      <div className="d-flex align-items-center headingMargin" style={{ position: "relative" }}>
        <div onClick={() => setClickFromCreate((prev) => !prev)}>
          <img src="/images/Back Arrow.svg" alt=""></img>
          <span className="published_hw_file_path1">
            &nbsp; Assessment /&nbsp;
          </span>
        </div>
        <span className="published_hw_file_path2">{name}</span>
        <div className="needfulinfo d-flex gap-4 align-item-center p-2" style={{ position: "absolute", top: "-70px", left: "210px" }}>
          <div className="allmarks">
            <div className="sktext d-flex justify-content-between flex-column"><span>Total Marks: {findTotalMarks()}</span> <span>Total Question: {questions.length}</span></div>
          </div>
          <div className="skills d-flex align-item-center justify-content-center border border-2 rounded-3" style={{ padding: "6px 15px" }}>
            <div className="needfulimg">
              <img src="/images/needfulimg.png" alt="needfulimg" style={{ width: "260px", marginRight: "12px" }}></img>
            </div>
            <div className="textpart">
              <h5 className="needful_heading">Skills</h5>
              {
                skillsData?.map((curr, index) => {
                  return (
                    <div className="sktext d-flex justify-content-between"> <span>{curr.name + " : "}</span> <span className="ms-3">{countSkills.Skills[curr.id] === undefined ? 0 : countSkills.Skills[curr.id]}</span></div>
                  )
                })

              }
            </div>
          </div>
          <div className="difficulty_level border border-2 rounded-3" style={{ padding: "6px 15px" }}>
            <h5 className="needful_heading">Difficulty Level</h5>
            {
              difficulty_levelData?.map((curr, index) => {
                return (
                  <div className="diftext d-flex justify-content-between"><span>{curr.name + " : "}</span> <span>{countDifficulty.DifficultyLevel[curr.id] === undefined ? 0 : countDifficulty.DifficultyLevel[curr.id]}</span></div>
                )
              })
            }
          </div>
          <div className="ques_type border border-2 rounded-3" style={{ padding: "6px 15px" }}>
            <h5 className="needful_heading">Question Type</h5>
            {
              questionType?.map((curr, index) => {
                return (
                  <div className="qstext d-flex justify-content-between"><span>{curr.name + " : "}</span> <span className="ms-3">0</span></div>
                )
              })
            }
          </div>
        </div>
      </div>
      <div className="mt-2 ms-1 published_tittle_heading">{description}</div>
      <div className="hw_question_container">
        <div className=" col-12 gap-2 p-0 flex-wrap mt-2 d-flex justify-content-between align-items-center">
          <div className="ms-1 col-md-2 p-0 hw_header_subject_name">
            {subject_id?.name}
          </div>
          <div className="col-md-6 p-0  flex-wrap d-flex">
            <div className=" col-md-9 py-1 p-0 d-flex justify-content-between  create_hw_marks_time_management ">
              <div className=" col-4 create_hw_qno_manage">
                <span>Total Questions :</span>
                <span>{questions.length}</span>
              </div>
              <div className=" col-4 create_hw_qno_manage">
                <span>Total Marks :</span>
                <span>{findTotalMarks()}</span>
              </div>
              <div className=" col-4 create_hw_qno_manage">
                <span>Total Duration :</span>
                <span> {total_duration} min</span>
              </div>
            </div>
          </div>
          <div className="d-flex col-md-2 flex-column">
            <div
              className="d-flex my-3 hw_library_btn"
              onClick={() => {
                setClick1(true);
                setSourceLibrary("FROM_SCHOOL_LIBRARY")
                }}
            >
              <img src="/images/add button.svg" alt="" />
              <span className="ms-2">Add From School Library</span>
            </div>
            <div
              className="d-flex hw_library_btn"
              onClick={() => {
                setClick1(true);
                setSourceLibrary("FROM_B4S_LIBRARY")
              }}
            >
              <img src="/images/add button.svg" alt="" />
              <span className="ms-2">Add from B4S Library</span>
            </div>
          </div>
        </div>

        {questions.length > 0 &&
          questions.map((question, index) => (
            <DefaultQuestion
              key={index}
              nextQuestion={index}
              question={question}
              setQuestions={setQuestions}
              assessmentDetails={assessmentDetails}
              qArr={questions}
              setSkillsData={setSkillsData}
              setDifficulty_levelData={setDifficulty_levelData}
              setQuestionType={setQuestionType}
            />
          ))}

        {!checkAllDataField() && (
          <div className="mt-2 d-flex align-items-center justify-content-center">
            <button
              id="Add-options-btn"
              className="btn  add_question_button"
              type="button"
              onClick={addMoreQuestion}
            >
              <img src="/images/add button.svg" className="mx-1" alt=""></img>
              Add question
            </button>
          </div>
        )}

        <div className="mt-2 me-2 d-grid gap-2 d-md-flex justify-content-md-end mt-5 ">
          <button
            onClick={handleCreateAssessment}
            disabled={checkAllDataField()}
            className="btn draft_button"
          >
            Save as Draft
          </button>

          <button
            disabled={checkAllDataField()}
            className="btn  next_button"
            onClick={(e) => setClick(true)}
          >
            Next
          </button>
        </div>
      </div >

      {click && (
        <QuestionListAssessment
          questions={questions}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          change={setClick}
          total_marks={findTotalMarks()}
          name={name}
          sourceLibrary={sourceLibrary}
        />
      )
      }

      {click1 && (
        <SelectFromLibr
          setClick1={setClick1}
          sourceLibrary={sourceLibrary}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          questions={questions}
        />
      )}

      {
        isInProgress && (
          <div className="loader_bg">
            <img className="qList_loader" src="/gif/LoaderDot.gif" alt="" />
          </div>
        )
      }
    </div>
  );
};

export default CreateQuestion;
